import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export type SvgLoaderSize = "responsive" | "intrinsic" | "none";

export interface SvgLoaderOptions extends AjaxLoaderOptions {
    size?: SvgLoaderSize;
}

export class SvgLoader extends AbstractAjaxLoader<SVGElement, SvgLoaderOptions>{

    protected async convert(svg: SVGElement): Promise<SVGElement> {
        let size: SvgLoaderSize = this._options.size;
        if (size === "none") {
            return svg;
        }

        var w = 150;
        var h = 150;

        if (svg.hasAttribute("width")) {
            w = parseFloat(svg.getAttribute("width"));
        } else if (svg.hasAttribute("viewBox")) {
            var values = svg.getAttribute("viewBox").split(/[\s,]+/i);
            if (values.length >= 4) {
                w = parseFloat(values[2]);
            }
        }

        if (svg.hasAttribute("height")) {
            h = parseFloat(svg.getAttribute("height"));
        } else if (svg.hasAttribute("viewBox")) {
            var values = svg.getAttribute("viewBox").split(/[\s,]+/i);
            if (values.length >= 4) {
                h = parseFloat(values[3]);
            }
        }

        if (size === "responsive") {
            if (!svg.getAttribute("viewBox")) {
                svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
                svg.removeAttribute("width");
                svg.removeAttribute("height");
            }
        }
        else if (size === "intrinsic") {
            if (!svg.hasAttribute("width")) {
                svg.setAttribute("width", w + "");
            }
            if (!svg.hasAttribute("height")) {
                svg.setAttribute("height", h + "");
            }
        }
 
        return svg;
    }

    protected defaultOptions(): SvgLoaderOptions {
        return {
            decoder: "svg",
            size: "none"
        }
    }
}

registerLoader("svg", SvgLoader);